import { Component, OnInit, HostListener } from '@angular/core';
import { RestApiService } from "../shared/restApiServices/restapi.service";
import { isUndefined } from 'util';
import { Router , ActivatedRoute} from '@angular/router';
import { PlanService } from "../shared/services/planService";

@Component({
  selector: 'app-sign-up-billing',
  templateUrl: './sign-up-billing.component.html',
  styleUrls: ['./sign-up-billing.component.css']
})
export class SignUpBillingComponent implements OnInit {

  notSupportedSize : boolean;
  plansOptions:any[] =[];
  selectedPlan:Plan;
  Name = '';
  Email = '';
  companyName = '';
  mobileNo = '';
  password = '';
  confirmpassword = '';
  verify:boolean = false;
  superAdminID:string = '';
  isShowLoader:boolean =  false;
  signUpFailMsg:string = '';
  userSubID = '';

  userNameEmpty:string = '';
  EmailEmpty:string = '';
  MobilenoEmpty:string = '';
  passwordEmpty:string = '';
  companyNameEmpty:string = '';

  verificationCode = '';
  codeEmpty:string = '';

  constructor(private restApiService:RestApiService,  private route: ActivatedRoute, private router: Router, private planService:PlanService) {
    if (window.screen.width < 900) {
      this.notSupportedSize = true;
    }
    else {
      this.notSupportedSize = false;
    }

    this.restApiService.getAllPlansData().subscribe(res=>{
      if(res && res.success == true){
        this.plansOptions = res.data;
        if(this.planService.getPlan())
        {
          this.selectedPlan = this.planService.getPlan();
        }
        else
        {
          this.selectedPlan = this.plansOptions[0];
        }
      }
      else{
         console.log('No Plans data available');
      }
    })

    if(this.route.queryParams['_value']['superAdminID'])
    {
      this.superAdminID = this.route.queryParams['_value']['superAdminID'];
    }
   }

  ngOnInit() {
  }

  selectPlan(id){
    this.selectedPlan = id[0];
  }

  logIn(){
    this.router.navigateByUrl('/logIn')
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  hasAcceptedTerms(){
    if(document.getElementById('scales')['checked'])
    {
      return true;
    }
    else {
      alert('Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy');
      return false;
    }
  }

  openWindow(link){
    window.open(link);
  }

  sendVerificationCode(){
    this.userNameEmpty = '';
    this.EmailEmpty = '';
    this.MobilenoEmpty = '';
    this.passwordEmpty = '';
    this.companyNameEmpty = '';

    if(this.Name==null || isUndefined(this.Name) || this.Name=="" || (this.Name && this.Name.trim() == ''))
    {
      this.userNameEmpty = "on-error";
      return;
    }
    else if(this.Email==null || isUndefined(this.Email) || this.Email=="" || !this.validateEmail(this.Email)
    || (this.Email && this.Email.trim() == ''))
    {
      this.EmailEmpty = "on-error";
      return;
    }
    else if(this.companyName==null || isUndefined(this.companyName) || this.companyName==""
    || (this.companyName && this.companyName.trim() == ''))
    {
      this.companyNameEmpty = "on-error";
      return;
    }
    else if(this.mobileNo==null || isUndefined(this.mobileNo) || this.mobileNo==""
    || (this.mobileNo && this.mobileNo.trim() == ''))
    {
      this.MobilenoEmpty = "on-error";
      return;
    }
    else if(this.password==null || isUndefined(this.password) || this.password=="" 
    || this.password !== this.confirmpassword  || (this.password && this.password.trim() == ''))
    {
      this.passwordEmpty = "on-error";
      return;
    }
    else if(!this.hasAcceptedTerms()){
      return;
    }
    else {
      this.userNameEmpty = "";
      this.EmailEmpty = "";
      this.MobilenoEmpty = "";
      this.passwordEmpty = "";
      this.isShowLoader = true;
      this.signUpFailMsg = "";

      this.restApiService.signUpService(this.Name, this.password,this.Email,this.mobileNo,this.superAdminID, this.selectedPlan['planID'], this.companyName).subscribe(
        result => {
          if(result.success)
          {
            this.isShowLoader = false;
            this.verify =  true;
            this.userSubID =  result.data.UserSub;
          }
          else {
            //signUp failed
            this.isShowLoader = false;
            this.signUpFailMsg = result.value;
          }
        })
    }


  }

  signUpRequest(){
    this.codeEmpty = "";
    if(this.verificationCode==null || isUndefined(this.verificationCode) || this.verificationCode=="")
    {
      this.codeEmpty = "on-error";
      return;
    }
    else{
      this.codeEmpty = "";
      this.isShowLoader=true;

      this.restApiService.confirmSignUpService(this.Email, this.verificationCode,this.selectedPlan['planID']).subscribe(
        result => {

          if(result.success)
          {
            let storageData = {
              accessToken: result.tokens.accessToken,
              refreshToken: result.tokens.refreshToken,
              idToken:result.tokens.idToken,
              exp: result.exp
            };
            localStorage.setItem('browserStorage', JSON.stringify(storageData));
            if(result.subscriptionID)
            {
              this.planService.setSubscription(result.subscriptionID);
            }

            if(result.planDetails.planID)
            {
              this.planService.setPlan(result.planDetails);
              if(result.planDetails.planID == 'plan_CXg9429wvx1STw')//free plan
              {
                this.router.navigateByUrl('/questionnaires') ;
              }
              else
              {
                this.router.navigateByUrl('/checkout');
              }
            }
            //assign survey
            this.restApiService.assignSurveyOnSignUp(this.userSubID).subscribe(
              result => {
                this.isShowLoader = false;
                if(result && result.success)
                {
                  // this.router.navigate(['/logIn'],{ queryParams: { email: this.Email} });
                }
              }
            );
          }
          else {
            //signUp failed
            this.isShowLoader = false;
            this.signUpFailMsg = result.value;
          }
        })
    }
  }


  onBack(){
    this.verify = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 900) {
      this.notSupportedSize = true;
    }
    else{
      this.notSupportedSize=false;
    }
    // event.target.innerWidth;

  }
}

export interface Plan {
  max_devices_old:number;
  max_devices_per_month: number;
  subscription_info: string;
  planName: string;
  price:number;
  numResponses:any;
  planID:any;
}



// WEBPACK FOOTER //
// ./src/app/sign-up-billing/sign-up-billing.component.ts